import { mapVariantToColor } from './styled';

export const buttonColor = mapVariantToColor;
